import { getLocaleString } from "./helpers/LocaleRegistry";

/**
 * User-facing string literals (v2).
 * All properties resolve through the locale registry.
 */
export const FormStrings = {
  get autoSavePending() { return getLocaleString("autoSavePending"); },
  get savePending() { return getLocaleString("savePending"); },
  get remaining() { return getLocaleString("remaining"); },
  get saving() { return getLocaleString("saving"); },
  get seeLess() { return getLocaleString("seeLess"); },
  get expand() { return getLocaleString("expand"); },
  get required() { return getLocaleString("required"); },
  get save() { return getLocaleString("save"); },
  get cancel() { return getLocaleString("cancel"); },
  get create() { return getLocaleString("create"); },
  get update() { return getLocaleString("update"); },
  get na() { return getLocaleString("na"); },
  get saveError() { return getLocaleString("saveError"); },
  get confirm() { return getLocaleString("confirm"); },
  get linkTitleLabel() { return getLocaleString("linkTitleLabel"); },
  get linkUrlLabel() { return getLocaleString("linkUrlLabel"); },
  get add() { return getLocaleString("add"); },
  get edit() { return getLocaleString("edit"); },
  get deleteLabel() { return getLocaleString("deleteLabel"); },
  get remove() { return getLocaleString("remove"); },
  get unknown() { return getLocaleString("unknown"); },
  get close() { return getLocaleString("close"); },
  get loading() { return getLocaleString("loading"); },
  get noResultsFound() { return getLocaleString("noResultsFound"); },
  get clickToClear() { return getLocaleString("clickToClear"); },
  get clear() { return getLocaleString("clear"); },
  get urlRequired() { return getLocaleString("urlRequired"); },
  get openExpandedTextEditor() { return getLocaleString("openExpandedTextEditor"); },
  get closeExpandedTextEditor() { return getLocaleString("closeExpandedTextEditor"); },
  get unsavedChanges() { return getLocaleString("unsavedChanges"); },
  get returnToEditing() { return getLocaleString("returnToEditing"); },
  get dontSave() { return getLocaleString("dontSave"); },
  get overview() { return getLocaleString("overview"); },
  get by() { return getLocaleString("by"); },
  get filterFields() { return getLocaleString("filterFields"); },
  get saved() { return getLocaleString("saved"); },
  get saveFailed() { return getLocaleString("saveFailed"); },
  get validating() { return getLocaleString("validating"); },
  get stepOf() { return getLocaleString("stepOf"); },
  get formWizard() { return getLocaleString("formWizard"); },
  get itemOfTotal() { return getLocaleString("itemOfTotal"); },
  get saveChangesTo() { return getLocaleString("saveChangesTo"); },
  get draftRecovered() { return getLocaleString("draftRecovered"); },
  get discardDraft() { return getLocaleString("discardDraft"); },
  get unsavedChangesWarning() { return getLocaleString("unsavedChangesWarning"); },
  get saveRetrying() { return getLocaleString("saveRetrying"); },
  get saveTimeout() { return getLocaleString("saveTimeout"); },
};

